import type { JSX } from 'react'
import type { IPositioningBlockProps } from '../PositioningBlock'

import { usePinnedBarBackground } from 'utils/hooks'
import { FIXED_INDENTS, NAVBAR_HEIGHT } from 'vars/index'
import { PositioningBlock } from '../PositioningBlock'
import { PositioningBlockPosition } from '../PositioningBlock.h'

export interface IStickyPositioningBlockProps extends IPositioningBlockProps {}

export const StickyPositioningBlock = ({
  children,
  position = PositioningBlockPosition.Sticky,
  top = NAVBAR_HEIGHT.DEFAULT,
  zIndex = 4,
  backgroundColor,
  paddings = [FIXED_INDENTS.INDENT_0],
}: IStickyPositioningBlockProps): JSX.Element => {
  const pinnedBarBackground = usePinnedBarBackground()

  return (
    <PositioningBlock
      position={position}
      top={top}
      zIndex={zIndex}
      backgroundColor={backgroundColor ?? pinnedBarBackground}
      paddings={paddings}
    >
      {children}
    </PositioningBlock>
  )
}
